import React from "react";

const CardActions = ({ className, children }) => {
    return <div className={`ActionsBar ${className ? className : ""}`}>{children}</div>;
};
export default CardActions;
